import { ContentRegistrationFormPayload } from '@/common/types';
import { downloadRecordFile } from '@/utils/file';
import { loadRecordFromFile } from '@/utils/record';
import { defineStore } from 'pinia';
import { useRecordStore } from '@/features/content-registration/stores/records';
import {DepositResponse} from "@content-registration/utils/deposit";
import { useNotificationStore } from './notifications';

/** Manages ephemeral session state for in-progress form data. */

const persistCurrentRecord = (record: ContentRegistrationFormPayload) => {
  const recordStore = useRecordStore();
  recordStore.saveDraft(record);
};

export const useSessionStore = defineStore('session', {
  state: () => ({
    currentRecord: null as ContentRegistrationFormPayload | null,
  }),
  actions: {
    setAndPersistCurrentRecord(record: ContentRegistrationFormPayload) {
      this.currentRecord = record;
      persistCurrentRecord(record);
    },
    setCurrentRecord(record: ContentRegistrationFormPayload) {
      this.currentRecord = record;
    },
    clearCurrentRecord() {
      this.currentRecord = null;
    },
    updateFormData(formData: any) {
      if (this.currentRecord) {
        this.setAndPersistCurrentRecord({
          ...this.currentRecord,
          formData,
        });
      } else {
        console.error('No current record found to update form data.');
      }
    },

    downloadRecord() {
      if (!this.currentRecord) {
        const notificationStore = useNotificationStore();
        notificationStore.addNotification('Could not find record to download.');
        return;
      }
      downloadRecordFile(this.currentRecord);
    },

    async loadRecordFromFile(file) {
      try {
        const record = await loadRecordFromFile(file);
        this.setCurrentRecord(record);
        return record;
      } catch (error) {
        console.error("Error loading record:", error);
        throw error; // re-throw to allow component-level handling
      }
    },
  },
  persist: {
    storage: sessionStorage,
  },
});
